 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9780310296065_COVER from '@/components/text/9780310296065_Cover'
 import TEXT9780310296065_PRAISE from '@/components/text/9780310296065_Praise'
 import TEXT9780310296065_RESOURCES from '@/components/text/9780310296065_Resources'
 import TEXT9780310296065_DEDICATION from '@/components/text/9780310296065_Dedication'
 import TEXT9780310296065_TITLEPAGE from '@/components/text/9780310296065_TitlePage'
 import TEXT9780310296065_COPYRIGHT from '@/components/text/9780310296065_Copyright'
 import TEXT9780310296065_FRONTMATTER1 from '@/components/text/9780310296065_Frontmatter1'
 import TEXTNAV from '@/components/text/nav'
 import TEXT9780310296065_FRONTMATTER from '@/components/text/9780310296065_Frontmatter'
 import TEXT9780310296065_PREFACE from '@/components/text/9780310296065_Preface'
 import TEXT9780310296065_CHAPTER_1 from '@/components/text/9780310296065_Chapter_1'
 import TEXT9780310296065_CHAPTER_2 from '@/components/text/9780310296065_Chapter_2'
 import TEXT9780310296065_CHAPTER_3 from '@/components/text/9780310296065_Chapter_3'
 import TEXT9780310296065_CHAPTER_4 from '@/components/text/9780310296065_Chapter_4'
 import TEXT9780310296065_CHAPTER_5 from '@/components/text/9780310296065_Chapter_5'
 import TEXT9780310296065_CHAPTER_6 from '@/components/text/9780310296065_Chapter_6'
 import TEXT9780310296065_CHAPTER_7 from '@/components/text/9780310296065_Chapter_7'
 import TEXT9780310296065_CHAPTER_8 from '@/components/text/9780310296065_Chapter_8'
 import TEXT9780310296065_CHAPTER_9 from '@/components/text/9780310296065_Chapter_9'
 import TEXT9780310296065_CHAPTER_10 from '@/components/text/9780310296065_Chapter_10'
 import TEXT9780310296065_SOURCES from '@/components/text/9780310296065_Sources'
 import TEXT9780310296065_PART01 from '@/components/text/9780310296065_Part01'
 import TEXT9780310296065_PART01_CHAPTER_1 from '@/components/text/9780310296065_Part01_Chapter_1'
 import TEXT9780310296065_PART01_CHAPTER_2 from '@/components/text/9780310296065_Part01_Chapter_2'
 import TEXT9780310296065_PART01_CHAPTER_3 from '@/components/text/9780310296065_Part01_Chapter_3'
 import TEXT9780310296065_PART01_CHAPTER_4 from '@/components/text/9780310296065_Part01_Chapter_4'
 import TEXT9780310296065_PART01_CHAPTER_5 from '@/components/text/9780310296065_Part01_Chapter_5'
 import TEXT9780310296065_PART01_CHAPTER_6 from '@/components/text/9780310296065_Part01_Chapter_6'
 import TEXT9780310296065_PART01_CHAPTER_7 from '@/components/text/9780310296065_Part01_Chapter_7'
 import TEXT9780310296065_PART01_CHAPTER_8 from '@/components/text/9780310296065_Part01_Chapter_8'
 import TEXT9780310296065_PART01_CHAPTER_9 from '@/components/text/9780310296065_Part01_Chapter_9'
 import TEXT9780310296065_PART01_CHAPTER_10 from '@/components/text/9780310296065_Part01_Chapter_10'
 import TEXT9780310296065_PART01_BACKMATTER from '@/components/text/9780310296065_Part01_Backmatter'
 import TEXT9780310296065_PART01_BACKMATTER1 from '@/components/text/9780310296065_Part01_Backmatter1'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9780310296065_Cover",
 			"name" : "text/9780310296065_Cover",
 			"component" : TEXT9780310296065_COVER
 		},
 		{
 			"path" : "/text/9780310296065_Praise",
 			"name" : "text/9780310296065_Praise",
 			"component" : TEXT9780310296065_PRAISE
 		},
 		{
 			"path" : "/text/9780310296065_Resources",
 			"name" : "text/9780310296065_Resources",
 			"component" : TEXT9780310296065_RESOURCES
 		},
 		{
 			"path" : "/text/9780310296065_Dedication",
 			"name" : "text/9780310296065_Dedication",
 			"component" : TEXT9780310296065_DEDICATION
 		},
 		{
 			"path" : "/text/9780310296065_TitlePage",
 			"name" : "text/9780310296065_TitlePage",
 			"component" : TEXT9780310296065_TITLEPAGE
 		},
 		{
 			"path" : "/text/9780310296065_Copyright",
 			"name" : "text/9780310296065_Copyright",
 			"component" : TEXT9780310296065_COPYRIGHT
 		},
 		{
 			"path" : "/text/9780310296065_Frontmatter1",
 			"name" : "text/9780310296065_Frontmatter1",
 			"component" : TEXT9780310296065_FRONTMATTER1
 		},
 		{
 			"path" : "/text/nav",
 			"name" : "text/nav",
 			"component" : TEXTNAV
 		},
 		{
 			"path" : "/text/9780310296065_Frontmatter",
 			"name" : "text/9780310296065_Frontmatter",
 			"component" : TEXT9780310296065_FRONTMATTER
 		},
 		{
 			"path" : "/text/9780310296065_Preface",
 			"name" : "text/9780310296065_Preface",
 			"component" : TEXT9780310296065_PREFACE
 		},
 		{
 			"path" : "/text/9780310296065_Chapter_1",
 			"name" : "text/9780310296065_Chapter_1",
 			"component" : TEXT9780310296065_CHAPTER_1
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js